"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LandingPage = void 0;
var _CategoryButtonList = require("../../components/CategoryButtonList/CategoryButtonList");
var _MostCommonQuestions = require("../../components/MostCommonQuestions/MostCommonQuestions");
var _SearchHeader = require("../../components/SearchHeader/SearchHeader");
var _jsxRuntime = require("react/jsx-runtime");
const LandingPage = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchHeader.SearchHeader, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CategoryButtonList.CategoryButtonList, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_MostCommonQuestions.MostCommonQuestions, {})
        ]
    });
exports.LandingPage = LandingPage;
